import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button } from '@chakra-ui/react';
import React from 'react';

interface Props {
  onEditDetails: () => void;
}

const EmailUnlinkedWarning: React.FC<Props> = ({ onEditDetails }) => (
  <Alert status="error" flexDirection="column" mb="4">
    <Box display="flex" mb={2}>
      <AlertIcon />
      <Box flex="1">
        <AlertTitle>The original email address has been unlinked from this application</AlertTitle>
        <AlertDescription>To add a new email address, please edit the applicant's details.</AlertDescription>
      </Box>
    </Box>

    <Button size="md" variant="solid" onClick={onEditDetails} ml={8}>
      Edit details
    </Button>
  </Alert>
);

export default EmailUnlinkedWarning;
